module.exports = __webpack_public_path__ + "7b47393eb28d51f136240ce506c95608.png";